import '../../other/WebpackConfig';
import gateway from './Gateway';

gateway();
